import { initMutationObserver, initScrollObserver, initAdoptedStyleSheetObserver } from './observer.js';
import { patch, inDom } from '../utils.js';
import { isNativeShadowDom } from '../../../rrweb-snapshot/es/rrweb-snapshot.js';

class ShadowDomManager {
    constructor(options) {
        this.shadowDoms = new WeakSet();
        this.restoreHandlers = [];
        this.restoreHandlersMap = new Map();
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    removeShadowRoot(shadowRoot) {
        const handlers = this.restoreHandlersMap.get(shadowRoot);
        if (handlers) {
            handlers.forEach((handler) => {
                if (window.requestIdleCallback) {
                    window.requestIdleCallback(handler);
                }
                else {
                    setTimeout(handler, 1);
                }
            });
            this.restoreHandlersMap.delete(shadowRoot);
        }
    }
    addShadowRoot(shadowRoot, doc) {
        if (!isNativeShadowDom(shadowRoot))
            return;
        if (this.shadowDoms.has(shadowRoot))
            return;
        this.shadowDoms.add(shadowRoot);
        const observer = initMutationObserver(Object.assign(Object.assign({}, this.bypassOptions), { doc, mutationCb: this.mutationCb, mirror: this.mirror, shadowDomManager: this }), shadowRoot);
        const scrollObserverCb = initScrollObserver(Object.assign(Object.assign({}, this.bypassOptions), { scrollCb: this.scrollCb, doc: shadowRoot, mirror: this.mirror }));
        this.restoreHandlersMap.set(shadowRoot, [
            () => observer.disconnect(),
            scrollObserverCb
        ]);
        setTimeout(() => {
            var _a;
            if (shadowRoot.adoptedStyleSheets &&
                shadowRoot.adoptedStyleSheets.length > 0)
                this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            (_a = this.restoreHandlersMap.get(shadowRoot)) === null || _a === void 0 ? void 0 : _a.push(initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager,
            }, shadowRoot));
        }, 0);
    }
    observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument)
            return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    }
    patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push(patch(element.prototype, 'attachShadow', function (original) {
            return function (option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && inDom(this))
                    manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler) => {
            try {
                handler();
            }
            catch (e) {
            }
        });
        this.restoreHandlers = [];
        this.restoreHandlersMap.forEach((handlers) => {
            handlers.forEach((handler) => {
                try {
                    handler();
                }
                catch (e) {
                }
            });
        });
        this.restoreHandlersMap = new Map();
        this.shadowDoms = new WeakSet();
    }
}

export { ShadowDomManager };
